import { useMutation } from "@tanstack/react-query";
import { App, Button, Form, Input, Modal } from "antd";
import { UsuarioService } from "../Services/UsuarioService";
import { useForm } from "antd/es/form/Form";
import { AxiosError } from "axios";

type TypeAlterarSenhaProps = {
    exibir: boolean,
    setExibir: (value: boolean) => void;
}

export function AlterarSenha({ exibir, setExibir }: TypeAlterarSenhaProps) {
    const { notification } = App.useApp();
    const [form] = useForm();

    const mutationAltearSenha = useMutation({
        mutationFn: (dadosNovaSenha: { senhaAtual: string, novaSenha: string, novaSenhaConf: string }) => new UsuarioService().alterarSenha(dadosNovaSenha),
        onSuccess: (data) => {
            notification.success({ message: data.data, placement: "top" });
            setExibir(false);
        },
        onError: (error: AxiosError) => {
            if (error.response?.status === 401)
                notification.error({ message: "Senha atual incorreta.", placement: "top" });
            else
                notification.error({ message: "Ocorreu um erro tente novamente mais tarde.", placement: "top" });
        }
    });

    function alterar(values: { senhaAtual: string, novaSenha: string, novaSenhaConf: string }) {
        mutationAltearSenha.mutate(values);
    }

    return(
    <Modal
        title="Alterar Senha"
        open={exibir}
        onOk={() => setExibir(false)}
        onCancel={() => setExibir(false)}
        afterOpenChange={() => form.resetFields()}
        footer={""}
    >
        <Form
            name="alterarSenha"
            onFinish={alterar}
            form={form}
            disabled={mutationAltearSenha.isPending}
            layout="vertical"
            >
            <Form.Item<{ senhaAtual: string, novaSenha: string, novaSenhaConf: string }>
                name="senhaAtual"
                label="Senha Atual"
                rules={[{ min: 6, max: 20, required: true, message: "Infome sua senha atual." }]}
                >
                    <Input.Password></Input.Password>
            </Form.Item>
            <Form.Item<{ senhaAtual: string, novaSenha: string, novaSenhaConf: string }>
                name="novaSenha"
                label="Nova Senha"
                rules={[{ min: 6, max: 20, required: true, message: "Infome sua nova senha." }]}
                >
                    <Input.Password></Input.Password>
            </Form.Item>
            <Form.Item<{ senhaAtual: string, novaSenha: string, novaSenhaConf: string }>
                name="novaSenhaConf"
                label="Confirmar Senha"
                dependencies={["novaSenha"]}
                rules={[
                    {
                      required: true,
                      message: 'Confirme sua senha.',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('novaSenha') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('A nova senha e a confirmação não iguais.'));
                      },
                    }),
                  ]}
                >
                    <Input.Password></Input.Password>
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit" loading={mutationAltearSenha.isPending} block>Alterar</Button>
            </Form.Item>
        </Form>
    </Modal>
    );
}